import React, { useEffect } from 'react';
import './Experience.css'; // Fichier CSS pour les styles personnalisés
import { FaCode, FaLock, FaBuilding, FaBrain, FaTree } from 'react-icons/fa';

function Experience() {
  useEffect(() => {
    const cards = document.querySelectorAll('.experience-card');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.5 });

    cards.forEach(card => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  const experiences = [
    {
      role: "Développeur Fullstack",
      company: "Université de Lille",
      description: "Création d'une application web pour la gestion des officiels d’athlétisme, incluant la gestion des comptes utilisateurs (ajout/retrait), un calendrier des compétitions et des disponibilités, ainsi qu'une gestion des formations, événements et qualifications. Base de données : PostgreSQL.",
      icon: <FaCode />
    },
    {
      role: "Développeur Fullstack",
      company: "Université de Lille",
      description: "Développement d'une application pour la classification des sentiments (positif, négatif, neutre) exprimés dans des tweets, en utilisant des algorithmes d'apprentissage supervisé tels que le Dictionnaire, KNN et Bayes.",
      icon: <FaBrain />
    },
    {
      role: "Apprenti en cybersécurité",
      company: "Secnumacademie ANSSI",
      description: "En tant qu'apprenti en cybersécurité à Secnumacademie ANSSI, j'ai suivi une formation avancée sur la plateforme secnumacademie.gouv.fr, acquérant des compétences cruciales dans la gestion des risques numériques. Cette formation m'a permis de maîtriser des techniques essentielles pour protéger les systèmes d'information contre les menaces croissantes.",
      icon: <FaLock />
    },
    {
      role: "Administrateur Système",
      company: "Université de Lille",
      description: "En tant qu'Administrateur Système, j'ai pris en charge la gestion des serveurs et des infrastructures cloud, tout en automatisant les processus de déploiement pour une meilleure efficacité opérationnelle. J'ai exploité OpenStack pour orchestrer des environnements cloud, facilitant ainsi la gestion des ressources et l'optimisation des performances.",
      icon: <FaBuilding />
    },
    {
      role: "Droit et protection de l'environnement",
      company: "Objectif2030",
      description: "J'ai participé à l'évaluation environnementale des politiques et projets de développement, en analysant leur impact sur les écosystèmes et les ressources naturelles. Ce travail a permis de proposer des solutions pour réduire les effets négatifs sur l'environnement tout en soutenant les initiatives de développement durable.",
      icon: <FaTree />
    },
    {
      role: "Stagiaire",
      company: "AlbideyNet",
      description: "Contribué au déploiement de la technologie 4G en réalisant des études terrain et en collectant des données sur les sites. J'ai utilisé Atoll pour planifier et optimiser le réseau, garantissant une couverture optimale. Mon rôle incluait la collaboration avec les équipes techniques pour ajuster le réseau aux besoins futurs. Ce projet a renforcé mes compétences en télécommunications et gestion de projet.",
      icon: <FaBuilding />
    }    
  ];

  return (
    <section id="experience" className="experience-section">
      <h1 className="experience-title">MES EXPERIENCES</h1>
      <div className="experience-container">
        {experiences.map((experience, index) => (
          <div key={index} className="experience-card">
            <div className="card-header">
              <div className="icon">{experience.icon}</div>
              <h3>{experience.role}</h3>
            </div>
            <h4>{experience.company}</h4>
            <p>{experience.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;
